import React from 'react';
import '../Style-Sheets/DivOfImages.css';
const DivOfImages = (props) => {
	//one time caling at ProductsImages
	return <div className={'DivOfImages'}>{props.children}</div>;
};

export default DivOfImages;
